// Auto-generated. Do not edit by hand. Files live in /public/manifest-images/<theme>/.
export const MANIFEST_IMAGE_FILES = {
  "courage": [
    "I_Carry_Courage_Forward.png",
    "I_Carry_Steady_Strength.png",
    "I_Carry_Strength_Through_Pressure.png",
    "I_Choose_Bravery_Over_Comfort.png",
    "I_Choose_Courage_in_Conversation.png",
    "I_Endure_With_Grace.png",
    "I_Face_Uncertainty_With_Resolve.png",
    "I_Face_What_I_Have_Avoided.png",
    "I_Honor_My_Endurance.png",
    "I_Keep_Going.png",
    "I_Learn_Through_Challenge.png",
    "I_Let_Courage_Grow_Through_Action.png",
    "I_Let_Courage_Replace_Avoidance.png",
    "I_Let_Resilience_Shape_Me.png",
    "I_Let_Setbacks_Strengthen_Me.png",
    "I_Meet_This_Day_With_Courage.png",
    "I_Move_Beyond_Fear.png",
    "I_Persist_With_Purpose.png",
    "I_Protect_My_Inner_Strength.png",
    "I_Recover_My_Power.png",
    "I_Refuse_to_Be_Defined_by_Hard_Seasons.png",
    "I_Release_the_Fear_of_Failure.png",
    "I_Rise_After_Difficulty.png",
    "I_Rise_After_Disappointment.png",
    "I_Stand_Firm_in_What_Matters.png",
    "I_Stay_Open_After_Hardship.png",
    "I_Trust_My_Ability_to_Recover.png",
    "I_Trust_My_Capacity_to_Adapt.png",
    "I_Trust_My_Resilience.png",
    "I_Trust_That_I_Can_Handle_More_Than_I_Think.png"
  ],
  "creativity": [
    "I_Begin_Before_I_Feel_Ready.png",
    "I_Carry_Vision_Forward.png",
    "I_Create_From_Truth.png",
    "I_Create_Without_Fear_of_Judgment.png",
    "I_Give_My_Vision_Time_to_Grow.png",
    "I_Honor_the_Vision_Within_Me.png",
    "I_Let_Beauty_Inform_My_Work.png",
    "I_Let_Courage_Support_Innovation.png",
    "I_Let_Creativity_Renew_Me.png",
    "I_Let_Curiosity_Lead_Me.png",
    "I_Let_Ideas_Take_Shape.png",
    "I_Let_Inspiration_Find_Me_in_Ordinary_Moments.png",
    "I_Move_Vision_Into_Action.png",
    "I_Protect_Time_for_Vision.png",
    "I_Release_Creative_Doubt.png",
    "I_Release_Fear_of_Being_Misunderstood.png",
    "I_Release_the_Need_to_Create_Perfectly.png",
    "I_Return_to_the_Creative_Practice.png",
    "I_See_Possibility_Beyond_Limits.png",
    "I_Trust_Creative_Discipline.png",
    "I_Trust_My_Creative_Voice.png",
    "I_Trust_My_Imagination.png",
    "I_Trust_My_Work_Can_Reach_Others.png",
    "I_Trust_That_Vision_Can_Evolve.png",
    "I_Trust_the_Seeds_of_Vision.png",
    "I_Use_What_I_Have_Now.png",
    "I_Welcome_Creative_Flow.png",
    "I_Welcome_Expansion_in_Thought.png",
    "I_Welcome_New_Perspectives.png",
    "I_Welcome_Originality.png"
  ],
  "discipline": [
    "I_Build_One_Step_at_a_Time.png",
    "I_Build_Through_Consistency.png",
    "I_Carry_Focus_Forward.png",
    "I_Choose_Discipline_Over_Mood.png",
    "I_Commit_to_What_Matters.png",
    "I_Direct_My_Energy_Wisely.png",
    "I_Finish_What_Matters.png",
    "I_Focus_Without_Rush.png",
    "I_Focus_on_Progress_Not_Perfection.png",
    "I_Focus_on_the_Next_Right_Thing.png",
    "I_Follow_Through.png",
    "I_Give_Full_Attention_to_One_Thing.png",
    "I_Honor_Deep_Work.png",
    "I_Keep_Promises_to_Myself.png",
    "I_Lead_Myself_Well.png",
    "I_Practice_Daily_Devotion.png",
    "I_Protect_My_Attention.png",
    "I_Release_Distraction.png",
    "I_Release_Procrastination.png",
    "I_Remove_What_Drains_Momentum.png",
    "I_Respect_My_Routine.png",
    "I_Return_After_Disruption.png",
    "I_Stay_Present_With_the_Process.png",
    "I_Strengthen_My_Discipline.png",
    "I_Strengthen_Patience_in_Practice.png",
    "I_Strengthen_Through_Repetition.png",
    "I_Train_My_Mind_Toward_Focus.png",
    "I_Trust_the_Fruit_of_Discipline.png",
    "I_Use_My_Time_Well.png",
    "I_Work_With_Clarity.png"
  ],
  "faith": [
    "I_Am_Guided.png",
    "I_Am_Supported.png",
    "I_Believe_Good_Can_Still_Unfold.png",
    "I_Believe_I_Am_Being_Led_Well.png",
    "I_Believe_My_Steps_Matter.png",
    "I_Believe_Peace_Can_Accompany_Uncertainty.png",
    "I_Believe_There_Is_Meaning_in_This_Season.png",
    "I_Carry_Faith_Forward.png"
  ]
};
